<template>
  <div
    class="modal fade fixed-right modal-new-user-manager"
    tabindex="-1"
    role="dialog"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-vertical" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Create new manager user</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <form>
            <p>The new user will be invited to activate their account when the placement commences.</p>

            <div class="decorative-divider"></div>

            <div class="form-group">
              <p class="control-label">First Name *</p>
              <input
                type="text"
                class="form-control"
                name="first_name"
                data-vv-as="first name"
                v-validate="'required'"
                v-model="stateFirstName"
              >

              <help-block field="first_name"/>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <p class="control-label">Last Name *</p>
              <input
                type="text"
                class="form-control"
                name="last_name"
                data-vv-as="last name"
                v-validate="'required'"
                v-model="stateLastName"
              >

              <help-block field="last_name"/>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <p class="control-label">Backup Email Address *</p>
              <input
                type="text"
                class="form-control"
                name="email"
                v-validate="'required|email'"
                v-model="stateEmail"
              >

              <help-block field="email"/>
            </div>
            <!-- /.form-group -->

            <div class="form-group">
              <label class="control-label">User Type</label>
              <p class="form-control-plaintext minimal">Manager</p>
            </div>
            <!-- /.form-group -->
            <div class="form-group">
              <label class="control-label">Agency *</label>

              <multiselect
                :value="agencySelected"
                :options="agencies"
                track-by="id"
                placeholder
                label="name"
                name="agency_id"
                data-vv-as="agency"
                :show-labels="false"
                @input="agencyWasSelected"
                :searchable="false"
                :allow-empty="false"
                v-validate="'required'"
              />
            </div><!-- /.form-group -->

            <div class="form-group">
              <label class="control-label">Phone</label>
              <input type="text" class="form-control" name="phone" v-model="statePhone" v-validate>
            </div><!-- /.form-group -->

            <ladda-button
              type="submit"
              class="btn btn-success"
              :click="storeManager"
              :arguments="[manager]"
              :validate="true"
              :done="managerWasCreated"
              :failed="failed"
            >Create User</ladda-button>
          </form>
        </div><!-- /.modal-body -->
      </div>
    </div>
  </div><!-- /.modal -->
</template>

<script>
import { managerComputed, managerMethods, agencyComputed } from 'vx/helpers'
import { stateMapper } from 'mixins/managers'
import { handleServerErrors } from 'utils'
import Multiselect from 'vue-multiselect'

export default {
  mixins: [stateMapper],

  props: {
    agencyDefault: {
      required: false
    }
  },

  components: {
    Multiselect
  },

  data () {
    return {
      agencySelected: null
    }
  },

  computed: {
    ...managerComputed,
    ...agencyComputed
  },

  mounted () {
    window.$(this.$el).on('show.bs.modal', this.resetComponent)
  },

  beforeDestroy () {
    window.$(this.$el).off('show.bs.modal', this.resetComponent)
  },

  methods: {
    ...managerMethods,

    failed (error) {
      if (error.response && error.response.status === 422) {
        handleServerErrors(error, this.$validator)
      }
    },

    resetComponent () {
      this.resetManager()

      this.$validator.reset()

      if (this.agencyDefault) {
        this.agencyWasSelected(this.agencyDefault)
      }
    },

    async agencyWasSelected (agency) {
      this.agencySelected = agency

      this.stateAgency = agency.id
    },

    managerWasCreated () {
      this.$emit('created', this.manager)

      window.$(this.$el).modal('hide')
    }
  }
}
</script>
